var _path, _g, _path2, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 7,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 63,
    height: 7,
    x: 65,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.277.787h62.292v6.188H65.277V.787Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127.339 3.55h-37.26L68.132.869 66.275 3.88l1.857 3.005L90.08 4.211h37.285c.105 0 .205-.129.205-.33 0-.21-.1-.33-.23-.33Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 62,
    height: 7,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.111.787h61.334v6.188H.11V.787Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.576 3.55H.316c-.13 0-.205.162-.205.33 0 .162.075.331.205.331h37.26l21.942 2.675 1.862-3.005L59.518.868 37.576 3.55Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 6,
    height: 7,
    x: 61,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.445.787h5.111v6.188h-5.11V.787Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.408 3.88c0 .34-.04.662-.12.976a2.93 2.93 0 0 1-.345.83 1.75 1.75 0 0 1-.509.555c-.194.13-.4.194-.609.194-.21 0-.409-.065-.604-.194a1.75 1.75 0 0 1-.509-.555 2.93 2.93 0 0 1-.344-.83 3.93 3.93 0 0 1-.12-.975c0-.347.04-.669.12-.983a2.93 2.93 0 0 1 .344-.83c.145-.242.32-.427.51-.556.194-.129.394-.193.603-.193.21 0 .415.064.61.193.189.13.364.314.508.556.15.242.265.516.345.83.08.314.12.636.12.983Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.a4d606626772f368e1837c1fc792ce9d.svg";
export { ForwardRef as ReactComponent };